import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';

const preferenceKey = 'radian-soul-theme';
type Theme = 'light' | 'dark';
export default function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => typeof document !== 'undefined' && document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light');
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'dark' ? '#211d32' : '#faf8f3');
  }, [theme]);
  useEffect(() => {
    const sync = (event: StorageEvent) => {
      if (event.key === preferenceKey || event.key === null) setTheme(event.newValue === 'dark' ? 'dark' : 'light');
    };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);
  const label = theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode';
  return <button className="theme-toggle" type="button" aria-label={label} title={label} onClick={() => {
    const next = theme === 'light' ? 'dark' : 'light';
    setTheme(next);
    try { localStorage.setItem(preferenceKey, next); } catch { /* Theme still works when storage is unavailable. */ }
  }}>{theme === 'light' ? <Moon size={19} aria-hidden="true"/> : <Sun size={19} aria-hidden="true"/>}</button>;
}
